var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-centerForm",
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: {
                    inline: "",
                    model: _vm.searchForm,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "规则名称", prop: "ruleName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入规则名称", clearable: "" },
                        model: {
                          value: _vm.searchForm.ruleName,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "ruleName", $$v)
                          },
                          expression: "searchForm.ruleName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "风险等级", prop: "riskLevel" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择风险等级",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.riskLevel,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "riskLevel", $$v)
                            },
                            expression: "searchForm.riskLevel",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "低", value: "low" },
                          }),
                          _c("el-option", {
                            attrs: { label: "中", value: "medium" },
                          }),
                          _c("el-option", {
                            attrs: { label: "高", value: "high" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "处理状态", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择处理状态",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "status", $$v)
                            },
                            expression: "searchForm.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "待处理", value: "pending" },
                          }),
                          _c("el-option", {
                            attrs: { label: "已处理", value: "processed" },
                          }),
                          _c("el-option", {
                            attrs: { label: "已忽略", value: "ignored" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "触发时间" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.searchForm.triggerTimeRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "triggerTimeRange", $$v)
                          },
                          expression: "searchForm.triggerTimeRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-search", type: "primary" },
                          on: { click: _vm.search },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-refresh-left" },
                          on: { click: _vm.resetSearch },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh" },
                  on: { click: _vm.refresh },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "v-tableEncapsulation",
        {
          attrs: {
            loading: _vm.loadingBtn.tableLoading,
            columnData: _vm.columnData,
            tableSize: _vm.pagination.size,
            tableData: _vm.tableData,
            tableTotal: _vm.pagination.total,
            currentPage: _vm.pagination.current,
          },
          on: {
            currentPage: _vm.handleCurrentChange,
            sizeChange: _vm.handleSizeChange,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              slot: "riskLevel",
              label: "风险等级",
              align: "center",
              width: "100px",
            },
            slot: "riskLevel",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getRiskLevelTagType(scope.row.riskLevel),
                          effect: "dark",
                        },
                      },
                      [_vm._v(" " + _vm._s(scope.row.riskLevelText) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              slot: "status",
              label: "处理状态",
              align: "center",
              width: "100px",
            },
            slot: "status",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getStatusTagType(scope.row.status),
                          effect: "dark",
                        },
                      },
                      [_vm._v(" " + _vm._s(scope.row.statusText) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              slot: "operate",
              label: "操作",
              align: "center",
              width: "100px",
              fixed: "right",
            },
            slot: "operate",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "异常检测详情",
            visible: _vm.detailDialogVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _vm.anomalyDetail.id
            ? _c(
                "el-descriptions",
                { attrs: { column: 2, border: "" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "规则编码" } }, [
                    _vm._v(_vm._s(_vm.anomalyDetail.ruleCode)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "规则名称" } }, [
                    _vm._v(_vm._s(_vm.anomalyDetail.ruleName)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "风险等级" } },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getRiskLevelTagType(
                              _vm.anomalyDetail.riskLevel
                            ),
                            effect: "dark",
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.anomalyDetail.riskLevelText) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("el-descriptions-item", { attrs: { label: "检测条件" } }, [
                    _vm._v(_vm._s(_vm.anomalyDetail.condition)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "处理方式" } }, [
                    _vm._v(_vm._s(_vm.anomalyDetail.handle)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "触发时间" } }, [
                    _vm._v(_vm._s(_vm.anomalyDetail.triggerTime)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "触发次数" } }, [
                    _vm._v(_vm._s(_vm.anomalyDetail.triggerCount)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "关联订单号" } },
                    [_vm._v(_vm._s(_vm.anomalyDetail.relatedOrderNo || "-"))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "关联会员ID" } },
                    [_vm._v(_vm._s(_vm.anomalyDetail.relatedMemberId))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "关联IP" } }, [
                    _vm._v(_vm._s(_vm.anomalyDetail.relatedIp)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "描述", span: 2 } },
                    [_vm._v(_vm._s(_vm.anomalyDetail.description))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "处理状态" } },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getStatusTagType(
                              _vm.anomalyDetail.status
                            ),
                            effect: "dark",
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.anomalyDetail.statusText) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("el-descriptions-item", { attrs: { label: "处理人" } }, [
                    _vm._v(_vm._s(_vm.anomalyDetail.processor || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "处理时间" } }, [
                    _vm._v(_vm._s(_vm.anomalyDetail.processTime || "-")),
                  ]),
                  _vm.anomalyDetail.detail
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "详情", span: 2 } },
                        [
                          _c("div", [
                            _c("p", [
                              _vm._v(
                                "请求次数：" +
                                  _vm._s(_vm.anomalyDetail.detail.requestCount)
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                "时间范围：" +
                                  _vm._s(_vm.anomalyDetail.detail.timeRange)
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                "IP列表：" +
                                  _vm._s(
                                    _vm.anomalyDetail.detail &&
                                      _vm.anomalyDetail.detail.ipList &&
                                      _vm.anomalyDetail.detail.ipList.join(", ")
                                  )
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                "会员列表：" +
                                  _vm._s(
                                    _vm.anomalyDetail.detail &&
                                      _vm.anomalyDetail.detail.memberList &&
                                      _vm.anomalyDetail.detail.memberList.join(
                                        ", "
                                      )
                                  )
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }